.productBox{
    padding: 24px;
    width: 280px;
    box-sizing: border-box;
}

.suiteBox{
    max-width: 575px;
    border: none!important;
}

.productBox.selected{
    border-color: #00aeef!important;
    box-shadow: 0 0 0 1px #00aeef;
}

.productBoxText{
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.productBoxTitle{
    color: rgba(0, 0, 0, 0.87);
    font-size: 24px;
    line-height: 32px;
    margin: 0;
}

.productBox p, .productBox li{
    margin-bottom: 0;
    color: rgba(0, 0, 0, 0.65);
}


.productBoxLogo{
    width: 48px;
    height: 48px;
    margin-bottom: 8px;
}

.productBoxLogo img{
    height: 100%;
    width: 100%
}

.productBoxBadge{
    height: 24px;
}

.bestValueContainer{
    width:100%;
    display: flex;
    justify-content: center;
}

.bestValue{
    background-color: #157AFF;
    color: white;
    padding: 0 8px;
    min-width: 90px;
    font-size: 14px;
    line-height: 24px;
    border-radius: 12px;
}

@media (max-width: 992px) {
    .productBox{
        width: 256px;
        border: none!important;
    }
}

@media (max-width: 825px){
    .productBoxFeatureList, .productBoxListHeader{
        display: none;
    }

    .altBox{
        display: none;
    }

    .productBox.selected{
        box-shadow: unset!important;
        border-color: rgba(0, 0, 0, 12%)!important;
    }
}

@media (max-width: 545px){
    .product-type-row{
        flex-direction: column;
        align-items: center;
    }
}